import { Box, Text, Skeleton, Grid, GridItem, Flex, Button } from "@chakra-ui/react";
import { useContext, useEffect, useState } from "react";
import { Footer } from "../../components/Footer";
import Navbar from "../../components/Navbar";
import { ProductCard } from "../../components/ProductCard";
import { CityContext } from '../../Context/CityContext';
import { api } from "../../services/api";
import { theme } from "../../styles/theme";
import { Filters } from "../../components/Filters";
import { useLocation, Link } from 'react-router-dom';
import { CartContext } from "../../Context/CartContext";
import { AddToCartPopUp } from "../../components/AddToCartPopUp";

export function Products() {
  const location = useLocation();
  const [products, setProducts] = useState([]);
  const [batches, setBatches] = useState([]);
  const [prices, setPrices] = useState([]);
  const [productTypes, setProductTypes] = useState([]);
  const [productsPhotos, setProductsPhotos] = useState({});
  const { cityName } = useContext(CityContext);
  const [loadingPage, setLoadingPage] = useState(true);
  const urlParams = new URLSearchParams(location.search);
  const { showCartPopUp } = useContext(CartContext);

  const PAGE_SIZE = 24;
  const [displayedCount, setDisplayedCount] = useState(PAGE_SIZE);

  useEffect(() => {
    const fetchProducts = async () => {
      const urlParams = new URLSearchParams(location.search);
      const filter = urlParams.get("filter");
      const brand = urlParams.get("brand");
      const query = urlParams.get("query");
      const order = urlParams.get("order");

      const params = new URLSearchParams();
      if (cityName) params.append("city", cityName);
      if (filter) params.append("filter", filter);
      if (brand) params.append("brand", brand);
      if (query) params.append("query", query);
      if (order) params.append("order", order);

      const apiUrl = `/api/v1/products?${params.toString()}`;
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      try {
        const response = await api.get(apiUrl);
        setProducts(response.data.products);
        setBatches(response.data.batches);
        setPrices(response.data.prices);
        setProductsPhotos(response.data.product_photos_url);
        setProductTypes(response.data.product_types);
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoadingPage(false);
      }
    };

    fetchProducts();
  }, [location.search]);

  // Reset to first page whenever the filter/query changes
  useEffect(() => {
    setDisplayedCount(PAGE_SIZE);
  }, [location.search]);


  const handleTypeToDisplay = () => {
    const filterParam = urlParams.get('filter');
    if (filterParam) {
      try {
        const filterArray = JSON.parse(filterParam);
        if (Array.isArray(filterArray)) {
          if (filterArray.includes("CERVEJA")) {
            return (
              <Text margin={{base: '0% 0% 5% 0%', md: '0% 0% 2% 0%'}} textAlign='start' fontSize={{base: '22px', md: '32px'}} fontWeight='bolder' color={theme.colors.primaryGreen}

              >Cervejas</Text>
            );
          } else if (filterArray.includes("Vinho")) {
            return (
              <Text margin={{base: '0% 0% 5% 0%', md: '0% 0% 2% 0%'}} textAlign='start' fontSize={{base: '22px', md: '32px'}} fontWeight='bolder' color={theme.colors.primaryGreen}

              >Vinhos e Espumantes</Text>
            );
          } else if (filterArray.includes("DESTILADOS")) {
            return (
              <Text margin={{base: '0% 0% 5% 0%', md: '0% 0% 2% 0%'}} textAlign='start' fontSize={{base: '22px', md: '32px'}} fontWeight='bolder' color={theme.colors.primaryGreen}

              >Destilados</Text>
            );
          } else if (filterArray.includes("OUTRAS BEBIDAS")) {
            return (
              <Text margin={{base: '0% 0% 5% 0%', md: '0% 0% 2% 0%'}} textAlign='start' fontSize={{base: '22px', md: '32px'}} fontWeight='bolder' color={theme.colors.primaryGreen}

              >Bebidas Prontas</Text>
            );
          } else if (filterArray.includes("Maiores Descontos")) {
            return (
              <Text margin={{base: '0% 0% 5% 0%', md: '0% 0% 2% 0%'}} textAlign='start' fontSize={{base: '22px', md: '32px'}} fontWeight='bolder' color={theme.colors.primaryGreen}

              >Maiores Descontos</Text>
            );
          } else if ( filterArray.includes("Mais Vendidos")) {
            return (
              <Text margin={{base: '0% 0% 5% 0%', md: '0% 0% 2% 0%'}} textAlign='start' fontSize={{base: '22px', md: '32px'}} fontWeight='bolder' color={theme.colors.primaryGreen}

              >Mais Vendidos</Text>
            );
          } else if (filterArray.includes("Kits")) {
            return (
              <Text margin={{base: '0% 0% 5% 0%', md: '0% 0% 2% 0%'}} textAlign='start' fontSize={{base: '22px', md: '32px'}} fontWeight='bolder' color={theme.colors.primaryGreen}

              >Kits</Text>
            );
          } else if (filterArray.includes("Acessórios")) {
            return (
              <Text margin={{base: '0% 0% 5% 0%', md: '0% 0% 2% 0%'}} textAlign='start' fontSize={{base: '22px', md: '32px'}} fontWeight='bolder' color={theme.colors.primaryGreen}

              >Acessórios</Text>
            );
          } else if (filterArray.includes("Não alcoólicos")) {
            return (
              <Text margin={{base: '0% 0% 5% 0%', md: '0% 0% 2% 0%'}} textAlign='start' fontSize={{base: '22px', md: '32px'}} fontWeight='bolder' color={theme.colors.primaryGreen}

              >Não Alcoólicos</Text>
            );
          } else if (filterArray.includes("Collab")) {
            return (
              <Text margin={{base: '0% 0% 5% 0%', md: '0% 0% 2% 0%'}} textAlign='start' fontSize={{base: '22px', md: '32px'}} fontWeight='bolder' color={theme.colors.primaryGreen}

              >Collab</Text>
            );
          } else if (filterArray.includes("Eventos, Buffets e Casamentos")) {
            return (
              <Text margin={{base: '0% 0% 5% 0%', md: '0% 0% 2% 0%'}} textAlign='start' fontSize={{base: '22px', md: '32px'}} fontWeight='bolder' color={theme.colors.primaryGreen}

              >Eventos, Buffets e Casamentos</Text>
            );
          } else if (filterArray.includes("Microcervejaria")) {
            return (
              <Text margin={{base: '0% 0% 5% 0%', md: '0% 0% 2% 0%'}} textAlign='start' fontSize={{base: '22px', md: '32px'}} fontWeight='bolder' color={theme.colors.primaryGreen}

              >Microcervejarias</Text>
            );
          } else if (filterArray.includes("Chopp")) {
            return (
              <Text margin={{base: '0% 0% 5% 0%', md: '0% 0% 2% 0%'}} textAlign='start' fontSize={{base: '22px', md: '32px'}} fontWeight='bolder' color={theme.colors.primaryGreen}

              >Chopp</Text>
            );
          } else if (filterArray.includes("Bebidas")) {
            return (
              <Text margin={{base: '0% 0% 5% 0%', md: '0% 0% 2% 0%'}} textAlign='start' fontSize={{base: '22px', md: '32px'}} fontWeight='bolder' color={theme.colors.primaryGreen}

              >Bebidas</Text>
            );
          }  else if (filterArray.includes("Novidades")) {
            return (
              <Text margin={{base: '0% 0% 5% 0%', md: '0% 0% 2% 0%'}} textAlign='start' fontSize={{base: '22px', md: '32px'}} fontWeight='bolder' color={theme.colors.primaryGreen}
              >Novidades</Text>
            );
          } else {
            return (
              <Text margin={{base: '0% 0% 5% 0%', md: '0% 0% 2% 0%'}} textAlign='start' fontSize={{base: '22px', md: '32px'}} fontWeight='bolder' color={theme.colors.primaryGreen}
              >Destaques</Text>
            );
          }
        }
      } catch (error) {
        console.log('Not an array');
      }
    } else {
      return (
        <Text margin={{base: '0% 0% 5% 0%', md: '0% 0% 2% 0%'}} textAlign='start' fontSize={{base: '22px', md: '32px'}} fontWeight='bolder' color={theme.colors.primaryGreen}
        >Produtos</Text>
      );
    }
  };


  return (
    <>
      <Navbar />

      <Box
        minH="100vh"
        bg="#f8f8f8"
        pt={{ base: "120px", md: "160px" }}
        pb={{ base: "48px", md: "64px" }}
      >
        <Box
          maxW="1700px"
          mx="auto"
          px={{ base: "16px", md: "32px" }}
        >
          <Flex
            direction={{ base: "column", xl: "row" }}
            align="flex-start"
            gap="32px"
          >
            <Box
              width="100%"
              flex={{ base: "1", xl: "0 0 320px" }}
              position={{ base: "relative", xl: "sticky" }}
              top={{ xl: "140px" }}
              height={{ xl: "calc(100vh - 160px)" }}
              overflow="hidden"
            >
              <Filters
                urlParams={urlParams}
                setProducts={setProducts}
                products={products}
              />
            </Box>

            {/* PRODUTOS */}
            <Box
              flex="1"
              position="relative"

            >
              {loadingPage && products?.length === 0 ? (
                <Grid
                  templateColumns={{
                    base: "repeat(2,minmax(150px,1fr))",
                    md: "repeat(3,minmax(0,1fr))",
                    lg: "repeat(4,minmax(0,1fr))",
                    xl: "repeat(5,minmax(0,1fr))"
                  }}
                  gap={{ base: "12px", md: "20px" }}
                >
                  {Array.from({ length: 10 }).map((_, i) => (
                    <Box key={i} borderRadius="20px" overflow="hidden">
                      <Skeleton height={{ base: "160px", md: "200px" }} borderRadius="20px 20px 0 0" />
                      <Box p="12px" bg="white" borderRadius="0 0 20px 20px">
                        <Skeleton height="16px" mb="8px" borderRadius="6px" />
                        <Skeleton height="14px" width="60%" mb="12px" borderRadius="6px" />
                        <Skeleton height="20px" width="80px" borderRadius="6px" />
                      </Box>
                    </Box>
                  ))}
                </Grid>
              ) : (
                <>
                  {products?.length > 0 && (
                    <Box mb="28px">
                      <Box w="36px" h="3px" bg="#fc8f04" borderRadius="99px" mb="10px" />
                      <Box
                        fontSize={{ base: "30px", md: "42px" }}
                        fontWeight="900"
                        color={theme.colors.primaryGreen}
                        letterSpacing="-1px"
                        mb="6px"
                        lineHeight="1.1"
                      >
                        {handleTypeToDisplay()}
                      </Box>
                      <Text color="gray.500" fontSize="15px">
                        {displayedCount < products.length
                          ? `Mostrando ${Math.min(displayedCount, products.length)} de ${products.length} produtos`
                          : `${products.length} produto${products.length !== 1 ? "s" : ""} encontrado${products.length !== 1 ? "s" : ""}`}
                      </Text>
                    </Box>
                  )}

                  <Grid
                    templateColumns={{
                      base: "repeat(2,minmax(150px,1fr))",
                      md: "repeat(3,minmax(0,1fr))",
                      lg: "repeat(4,minmax(0,1fr))",
                      xl: "repeat(5,minmax(0,1fr))"
                    }}
                    gap={{
                      base: "12px",
                      md: "20px"
                    }}
                  >
                    {/* Nenhum Produto */}
                    {products?.length <= 0 && !loadingPage && (
                      <GridItem
                        colSpan={{
                          base: 2,
                          md: 3,
                          lg: 4,
                          xl: 5
                        }}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        minH="400px"
                      >
                        <Box
                          bg="white"
                          p="40px"
                          borderRadius="24px"
                          border="1px solid rgba(0,74,51,.08)"
                          boxShadow="0 12px 30px rgba(0,74,51,.08)"
                        >
                          <Text
                            textAlign="center"
                            fontSize="24px"
                            color={theme.colors.primaryGreen}
                            fontWeight="900"
                          >
                            Nenhum produto encontrado
                          </Text>

                          <Text
                            mt="8px"
                            textAlign="center"
                            color="gray.500"
                          >
                            Tente alterar os filtros aplicados.
                          </Text>
                        </Box>
                      </GridItem>
                    )}

                    {/* Produtos */}
                    {products?.length > 0 &&
                      prices?.length > 0 &&
                      products.slice(0, displayedCount).map((product) => (
                        <GridItem
                          key={product.id}
                          width="100%"
                        >
                          <Link
                            to={`/produtos/${productTypes
                              ?.find(
                                (e) => e.id === product.product_type_id
                              )
                              ?.name.replace(/(%20|\s+)/g, "+")}/${product.name.replace(
                              /(%20|\s+)/g,
                              "+"
                            )}`}
                          >
                            <ProductCard
                              key={product.id}
                              product={product}
                              id={product.id}
                              name={product.name}
                              prices={prices?.filter(
                                (element) =>
                                  element.batch_id ===
                                  batches?.find(
                                    (element) =>
                                      element.product_id === product.id
                                  )?.id
                              )}
                              brand={product.brand}
                              description={product.description}
                              marketPrice={product.market_price}
                              quantityPerBox={product.quantity_per_box}
                              size={product.size}
                              productTypeId={product.product_type_id}
                              productType={product.product_type}
                              suggestedPriceForSale={
                                product.suggested_price_for_sale
                              }
                              batch={batches?.find(
                                (element) =>
                                  element.product_id === product.id
                              )}
                              productPhotoUrl={
                                productsPhotos[product.id]
                              }
                              productTypes={productTypes}
                            />
                          </Link>
                        </GridItem>
                      ))}
                  </Grid>

                  {/* Load more button */}
                  {!loadingPage && displayedCount < products.length && (
                    <Box display="flex" flexDir="column" alignItems="center" gap="10px" mt="40px" mb="20px">
                      <Button
                        onClick={() => setDisplayedCount(prev => Math.min(prev + PAGE_SIZE, products.length))}
                        variant="outline"
                        borderColor="rgba(0,74,51,.25)"
                        color="#004a33"
                        borderRadius="99px"
                        px="32px"
                        h="48px"
                        fontWeight="700"
                        fontSize="14px"
                        _hover={{ bg: "rgba(0,74,51,.05)", borderColor: "#004a33" }}
                      >
                        Carregar mais {Math.min(PAGE_SIZE, products.length - displayedCount)} produtos
                      </Button>
                      <Text fontSize="12px" color="gray.400">
                        {displayedCount} de {products.length} produtos
                      </Text>
                    </Box>
                  )}
                </>
              )}
            </Box>
          </Flex>
        </Box>
      </Box>

      <Footer />

      {showCartPopUp && <AddToCartPopUp />}
    </>
  );
}
